import styled from '@emotion/styled';
import DropdownListBox from '../common/DropdownListBox';
import { FormLabel } from '../form.styles';

export const DropdownCheckboxListWrapper = styled.div<{
  hasLabel: boolean;
}>`
  position: relative;

  ${FormLabel} {
    margin-bottom: 8px;
    display: inline-block;
  }
`;

export const StyledDropdownListBox = styled(DropdownListBox)`
  min-width: 280px;
  width: unset;
`;

export default {
  DropdownCheckboxListWrapper,
  StyledDropdownListBox,
};
